export enum MessageStatus {
  CREATED = "CREATED",
  QUEUED = "QUEUED",
  SCHEDULED = "SCHEDULED",
  SENDING = "SENDING",
  SENT = "SENT",
  UNDELIVERED = "UNDELIVERED",
  DELIVERED = "DELIVERED",
  READ = "READ",
  FAILED = "FAILED",
  EXPIRED = "EXPIRED",
  OPTED_OUT = "OPTED_OUT",
}

export enum MessageType {
  REMINDER = "REMINDER",
  OVERRIDE = "OVERRIDE",
  FOLLOW_UP = "FOLLOW_UP",
  EXPIRED = "EXPIRED",
  CANCELLED = "CANCELLED",
  UPDATE = "UPDATE",
  CONFIRMATION = "CONFIRMATION",
  NO_SHOW = "NO_SHOW",
  OUTREACH = "OUTREACH",
  WAITLIST = "WAITLIST",
}

export enum MessageKind {
  DEFAULT = "DEFAULT",
  EVENT = "EVENT",
  WAITLIST = "WAITLIST",
}
